import React from 'react';
import { styled } from '@linaria/react';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  as?: 'input' | 'textarea';
  label: string;
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
}

function LabeledInput({
  as,
  label,
  value,
  setValue,
  style = {},
  ...delegated
}: Props) {
  const id = React.useId();

  return (
    <div>
      <Label htmlFor={id}>{label}</Label>
      <Input
        // The placeholder is randomly generated, and there will be a hydration mismatch as the client generates a different random value. We can safely ignore this
        suppressHydrationWarning
        as={as}
        id={id}
        value={value}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          setValue(event.target.value)
        }
        style={{
          minHeight: as === 'textarea' ? '14rem' : undefined,
          ...style,
        }}
        {...delegated}
      />
    </div>
  );
}

const Label = styled.label`
  display: block;
  margin-bottom: 0.25rem;
  font-size: 1rem;
  color: var(--color-gray-900);
  transform: translateX(-1px);
`;

const Input = styled.input`
  display: block;
  width: 100%;
  /* Don’t allow textareas to be resized beyond the container */
  max-width: 100%;
  border: 1px solid var(--color-gray-300);
  border-radius: 2px;
  font-size: 1rem;
  padding: 4px 8px;
  outline-color: var(--color-primary);
  outline-offset: 4px;
`;

export default LabeledInput;
